import React, { useState } from 'react';

const keyframes = `
  @keyframes shIconGlow {
    0%,100% { filter: drop-shadow(0 0 2px rgba(0,245,160,0.4)); }
    50%      { filter: drop-shadow(0 0 7px rgba(0,245,160,0.9)); }
  }
`;

const RelIcons = {
  spouse:  (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>,
  child:   (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M8 21v-2a4 4 0 014-4h0a4 4 0 014 4v2"/><path d="M5 16l-2 5M19 16l2 5"/></svg>,
  sibling: (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><circle cx="8" cy="7" r="4"/><path d="M2 21v-2a6 6 0 016-6h0a6 6 0 016 6v2"/><circle cx="18" cy="7" r="3"/><path d="M21 21v-2a5 5 0 00-5-5"/></svg>,
  friend:  (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><circle cx="10" cy="8" r="4"/><path d="M2 21v-2a6 6 0 016-6h4a6 6 0 016 6v2"/><path d="M18 10l1.5 1.5L22 9"/></svg>,
  notary:  (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="8" y1="13" x2="16" y2="13"/><line x1="8" y1="17" x2="16" y2="17"/></svg>,
  family:  (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/><path d="M12 7l0 .01"/></svg>,
  other:   (c) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={c} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><line x1="19" y1="8" x2="19" y2="14"/><line x1="22" y1="11" x2="16" y2="11"/></svg>,
};

const CheckSvg = () => (
  <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="#0A1628" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12"/>
  </svg>
);

const RELATIONS = [
  { id: 'spouse',  label: 'Conjoint(e)',        },
  { id: 'child',   label: 'Enfant',             },
  { id: 'sibling', label: 'Frère / Sœur',       },
  { id: 'friend',  label: "Ami(e) de confiance" },
  { id: 'notary',  label: 'Notaire',            },
  { id: 'family',  label: 'Autre famille',      },
  { id: 'other',   label: 'Autre',              },
];

const BeneficiaryRelationPicker = ({ value = null, onChange }) => {
  const [selected, setSelected] = useState(value);

  const handle = (id) => {
    setSelected(id);
    onChange && onChange(id);
  };

  return (
    <>
      <style>
        {`
          ${keyframes}
          .sh-rel-icon { animation: shIconGlow 3.5s ease-in-out infinite; }
          .sh-rc:hover  { border-color: rgba(255,255,255,0.22) !important; }
          .sh-rc.sh-on  { border-color: rgba(0,245,160,0.55) !important; }
          .sh-rc.sh-on .sh-rc-lbl { color: #fff !important; }
          .sh-rc.sh-on .sh-ck     { opacity: 1 !important; }
        `}
      </style>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '6px' }}>
        {RELATIONS.map((rel, i) => (
          <div
            key={rel.id}
            className={`sh-rc${selected === rel.id ? ' sh-on' : ''}`}
            onClick={() => handle(rel.id)}
            style={{
              position: 'relative',
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '9px',
              padding: '12px 8px 10px',
              cursor: 'pointer',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '6px',
              textAlign: 'center',
              transition: 'border-color 0.15s',
            }}
          >
            <div className="sh-ck" style={{
              position: 'absolute', top: '6px', right: '6px',
              width: '12px', height: '12px', borderRadius: '50%',
              background: '#00F5A0', display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              opacity: 0, transition: 'opacity 0.2s',
            }}>
              <CheckSvg />
            </div>

            <span className="sh-rel-icon" style={{ animationDelay: `${i * 0.1}s` }}>
              {RelIcons[rel.id]?.('#00F5A0')}
            </span>

            <p className="sh-rc-lbl" style={{
              color: '#8892A4', fontSize: '11px', fontWeight: 500,
              lineHeight: 1.25, margin: 0, transition: 'color 0.15s',
            }}>
              {rel.label}
            </p>
          </div>
        ))}
      </div>
    </>
  );
};

export { RELATIONS };
export default BeneficiaryRelationPicker;
